import * as React from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { formatDate } from '../../helpers/dateConverters';
import type { PostDraftInterface } from '../../interfaces/post.interface';
import type { TextBlock } from '../../interfaces/textEditor.interface';

type UserPostsProps = {
  postReplyDrafts: PostDraftInterface[];
};

export default function PostReplyDrafts(props: UserPostsProps) {
  const params = useParams();
  const { username } = params;
  const dispatch = useDispatch();
  const { postReplyDrafts } = props;
  const [reversedDrafts, setReversedDrafts] = React.useState<
    PostDraftInterface[]
  >([]);

  const getTitle = (textBlocks: TextBlock[]) => {
    // Reply titles are H3 (TRIL-258); older replies may be H1 — match the first
    // heading at any level so the title shows regardless.
    const headingBlock = textBlocks?.find((block) => block.type === 'Heading');
    return headingBlock ? headingBlock.data?.header : 'Untitled Post';
  };

  useEffect(() => {
    if (postReplyDrafts?.length) {
      const reversed = postReplyDrafts?.length
        ? [...postReplyDrafts].reverse()
        : [];
      setReversedDrafts(reversed);
    }
  }, [postReplyDrafts]);

  return (
    <div className="POST__REPLY__DRAFTS__CONTAINER">
      {reversedDrafts === null ||
      reversedDrafts === undefined ||
      reversedDrafts.length < 1 ? (
        <>No Drafts</>
      ) : (
        reversedDrafts?.map((draft: PostDraftInterface) => (
          <div
            key={`${draft.parentPostId}-${draft.id}`}
            className="POST__REPLY__DRAFT__ITEM"
          >
            <Link
              style={{ textDecoration: 'none' }}
              to={`/post-reply-draft/${draft.id}`}
            >
              <div className="DRAFT__CARD">
                <div className="DRAFT__CARD__CONTENT">
                  <h6 className="DRAFT__CARD__TITLE">
                    {getTitle(draft.textBlocks)}
                  </h6>
                  <p className="DRAFT__CARD__DATE">
                    Created on: {formatDate(draft.createdAt as Date)}
                    {draft.updatedAt && draft.updatedAt !== draft.createdAt && (
                      <> — Updated on: {formatDate(draft.updatedAt as Date)}</>
                    )}
                  </p>
                </div>
              </div>
            </Link>
          </div>
        ))
      )}
    </div>
  );
}
